import React, {
    useContext, useMemo, useEffect, useState,
} from "react";
import TableComparison from "@_components/table-comparison";


function splitHtmlByDataType(html) {
    // Regex to match elements with a data-type attribute
    const regex = new RegExp(
        `<(\\w+)\\s([^>]*)data-type=["']([^"']+)["'][^>]*>(.*?)<\\/\\1>`,
        'gs' // 'g' for global, 's' to match across lines
    );

    let result = [];
    let lastIndex = 0;

    // Find matches and split the HTML
    let match;
    while ((match = regex.exec(html)) !== null) {
        const [fullMatch, tagName, attributes, dataType, content] = match;

        // Add the HTML part before this matched element
        if (lastIndex < match.index) {
            result.push({
                type: "html",
                content: html.slice(lastIndex, match.index),
            });
        }

        // Parse attributes into an object
        const attributesObj = {};
        const attrRegex = /(\w+)(?:=["']([^"']*)["'])?/g;
        let attrMatch;

        while ((attrMatch = attrRegex.exec(attributes)) !== null) {
            const [_, key, value] = attrMatch;
            attributesObj[`data-${key}`] = value || null;
        }

        // Add the matched element with data-type as type
        result.push({
            type: dataType, // Set the type to the value of data-type
            ...attributesObj,
            content: content.trim(),
        });

        // Update the lastIndex to the end of this match
        lastIndex = regex.lastIndex;
    }

    // Add any remaining HTML content after the last match
    if (lastIndex < html.length) {
        result.push({
            type: "html",
            content: html.slice(lastIndex),
        });
    }

    return result;
}


const ParsedContent = ({ content }) => {
  let tablePosition = splitHtmlByDataType(content);

  return <div>
    {tablePosition.map((item, index) => {
      if (item.type === "table-comparison") {
        return <TableComparison key={index} />;
      }
      return <div key={index} dangerouslySetInnerHTML={{ __html: item.content }} />;
    })}
  </div>
}

export default ParsedContent;